import React from "react";
import { Box, Button, Typography, Container } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import letsLearnImage from "../../styles/images/Rectangle 18.png";
import "../../styles/components.css";
import footerLogo from "../../styles/images/footerLogo.png";

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Box maxWidth={"1280px"} margin="auto">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              className="nav-brand-text"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: 20,
                fontWeight: 700,
              }}
            >
              <img
                src={"/logo.svg"}
                alt="Fan Trade Logo"
                className="footer-brand-image"
              />
              Fantrade
            </Typography>
          </Box>

          <Box className="auth-buttons-container">
            <Button onClick={() => navigate("/login")} className="auth-button">
              Sign In
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate("/signup")}
              sx={{ borderRadius: "24px" }}
            >
              Sign Up
            </Button>
          </Box>
        </Box>

        {/* Hero Section */}
        <Box className="hero-section">
          {/* Content Container */}
          <Box className="hero-content">
            <Typography variant="h1" className="hero-title">
              Master the Markets with
              <br />
              Smart Trading Strategies
            </Typography>

            <Typography variant="body1" className="hero-description">
              Lorem ipsum dolor sit amet consectetur adipiscing eli mattis sit
              phasellus mollis sit aliquam sit nullam neque ultrices.
            </Typography>

            <Button
              variant="contained"
              onClick={() => navigate("/signup")}
              className="hero-button"
            >
              Get started
              <ArrowForwardIcon />
            </Button>
          </Box>
        </Box>

        {/* Main Content Group */}
        <Box className="main-content">
          {/* How Fan Trade Works Section */}
          <Box sx={{ mb: 8, textAlign: "center" }}>
            <Typography variant="h4" className="section-title">
              How Fan Trade Works
            </Typography>
            <Typography variant="body1" className="section-description">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor magna aliqua
            </Typography>

            {/* Feature Cards Container */}
            <Box className="feature-cards-container">
              {/* Learn Fantrade Card */}
              <Box className="feature-card">
                <Box className="feature-icon-container">
                  <img
                    src="/fan-trade-icon.svg"
                    alt="fan-trade-icon.svg"
                    className="feature-icon"
                  />
                </Box>
                <Typography className="feature-title">
                  Learn Fantrade
                </Typography>
              </Box>

              {/* How to Trade Card */}
              <Box className="feature-card">
                <Box className="feature-icon-container">
                  <img
                    src="/fan-trade-icon.svg"
                    alt="fan-trade-icon.svg"
                    className="feature-icon"
                  />
                </Box>
                <Typography className="feature-title">How to Trade</Typography>
              </Box>

              {/* Build Portfolio Card */}
              <Box className="feature-card">
                <Box className="feature-icon-container">
                  <img
                    src="/fan-trade-icon.svg"
                    alt="fan-trade-icon.svg"
                    className="feature-icon"
                  />
                </Box>
                <Typography className="feature-title">
                  Build Portfolio
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Currency Works Section */}
          <Box className="currency-section">
            {/* Image Container - Now First */}
            <Box className="currency-image">
              <img src={letsLearnImage} alt="Trading App Interface" />
            </Box>

            {/* Text Content - Now Second */}
            <Box
              className="currency-content"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <Typography variant="h4" className="currency-title">
                  Let&apos;s learn how Fantrade Currency Works!
                </Typography>
                <Typography className="currency-description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                  irure dolor in reprehenderit in voluptate velit esse cillum
                  dolore eu fugiat nulla pariatur. Excepteur sint occaecat
                  cupidatat non proident, sunt in culpa qui officia deserunt
                  mollit anim id est laborum.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box className="footer-section">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "1280px",
            margin: "auto",
            height: "135px",
          }}
        >
          <Box className="footer-brand">
            <img
              src={footerLogo}
              alt="Fan Trade Logo"
              className="footer-brand-image"
            />
            <Typography className="footer-brand-text">Fantrade</Typography>
          </Box>

          <Typography className="footer-copyright">
            Copyright © 2025 Fan Trade | All Rights Reserved
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Home;
